import React from 'react'

export default function Label(props) {
  return (
    <label {...props} className='form-label'>
      {props.value}
    </label>
  )
}
